import {DesignBlockFilesModalConfig, DesignBlocksModalConfig} from "../types/product-card-design-blocks.types";
import {
  BaseDesignBlockModalComponent
} from "../components/modals/base-design-block-modal/base-design-block-modal.component";
import {
  DesignBlockFilesModalComponent
} from "../components/modals/design-block-files-modal/design-block-files-modal.component";
import {ListingFilesModalComponent} from "../components/modals/listing-files-modal/listing-files-modal.component";
import {BannersSocialModalComponent} from "../components/modals/banners-social-modal/banners-social-modal.component";

const DESIGN_FIELDS = [
  'listings',
  'richContent',
  'baseVideos',
  'aiVideos',
  'packageDesignDetails',
  'rawPhotos',
  'rawVideos',
  'otherContent',
  'banners',
  'socialMedia',
  'mainPhoto'
] as const;

function createConfig<T>(fields: readonly string[], baseConfig: Omit<T, 'fieldName'>, overrides?: Record<string, Partial<T>>): Record<string, T> {
  return Object.fromEntries(
    fields.map(fieldName => {
      const override = overrides?.[fieldName] || {};
      return [
        fieldName,
        {
          ...baseConfig,
          ...override,
          fieldName
        } as T
      ];
    })
  );
}

export const designBlocksModalConfig = createConfig<DesignBlocksModalConfig>(
  DESIGN_FIELDS,
  {
    component: BaseDesignBlockModalComponent,
    width: '450px'
  }
);

export const designBlockFilesModalConfig = createConfig<DesignBlockFilesModalConfig>(
  DESIGN_FIELDS,
  {
    component: DesignBlockFilesModalComponent,
    width: '90vw'
  },
  {
    listings: {
      component: ListingFilesModalComponent
    },
    richContent: {
      component: ListingFilesModalComponent
    },
    banners: {
      component: BannersSocialModalComponent
    },
    socialMedia: {
      component: BannersSocialModalComponent
    }
  }
);
